// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3icc7","content":"styles_content__3vOO_","row":"styles_row__2RNBy","footer":"styles_footer__1LLld","phraseLength":"styles_phraseLength__1aovI"};